<script setup lang="ts">
defineProps<{
	stepLabel: string;
	detail: string;
	progressClass: string;
	currentStep: number;
}>();

const TOTAL_STEPS = 3;
</script>

<template>
	<div>
		<div class="flex justify-between text-[13px] text-[#A3A3A3]">
			<span>{{ stepLabel }}</span>
			<span>{{ detail }}</span>
		</div>
		<div
			role="progressbar"
			:aria-label="stepLabel"
			aria-valuemin="1"
			:aria-valuemax="TOTAL_STEPS"
			:aria-valuenow="currentStep"
			class="mt-2.5 h-1 rounded-[4px] bg-[#262626]"
		>
			<div :class="['h-1 rounded-[4px] bg-beige', progressClass]" />
		</div>
	</div>
</template>
